import React from 'react';
import PropTypes from 'prop-types';
import './file-type.scss';
/**
 * @typedef {'small' | 'large' | 'medium'} SizeType - Size choices for the Demo component.
 */

/**
 * Component to demonstrate different sizes, appearances, and popup options.
 * @param {Object} props - Component props.
 * @param {SizeType} props.size - Size of the component ('Small' or 'Large').
 * @returns {JSX.Element} - Rendered component.
 */
function FileType({ extantion, size }) {
  const sizesProperties = {
    small: 'small',
    medium: 'medium',
    large: 'large',
  };

  const sizeProps = sizesProperties[size];
  return (
    <span className={`file-format ${extantion} ${sizeProps}`}>
      <span className="lines">&nbsp;</span>
      <span className="format">{extantion}</span>
    </span>
  );
}

export default FileType;

FileType.propTypes = {
  extantion: PropTypes.string,
  size: PropTypes.string,
};
FileType.defaultProps = {
  extantion: '',
  size: '',
};
